<template>
  <div>
    <div class="flex flex-between bg">
      <div class="flex-start  item-center">
        <el-radio-group
          class="mr10"
          size="small"
          style="margin-top: 20px"
          v-model="active"
        >
          <el-radio-button label="0">代理商户提现</el-radio-button>
          <el-radio-button label="1">商户提现</el-radio-button>
        </el-radio-group>
      </div>
      <div class="bg flex-end item-center" v-if="active == 0">
        <el-date-picker
                v-model="searchCondition.queryTime"
                clearable
                class="mr10"
                size="small"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
        </el-date-picker>
        <el-select v-model="searchCondition.auditState" filterable clearable size="small" class="mr10" placeholder="请选择审核状态">
          <el-option
                  v-for="(item,i) in statusList"
                  :key="i"
                  :label="item.label"
                  :value="item.value">
          </el-option>
        </el-select>
        <el-input
                placeholder="请输入提现单号/会员姓名/电话"
                v-model="searchCondition.keyWord"
                size="small"
                style="width: 320px"
                class="mr20"
                clearable>
        </el-input>
        <el-button type="primary" size="small" @click="paging(1)"
        >查询</el-button
        >
        <!--<el-button type="primary" size="small" class="ml10"
        >生成报表</el-button
        >-->
      </div>
      <div v-if="active==1"  class="bg flex-end item-center">
        <el-select size="small" placeholder="请选择提现状态" clearable class="mr10" v-model="conditionQuery.auditState">
          <el-option
                  v-for="(v,i) in auditState"
                  :label="v.label"
                  :value="v.value"
                  :key="i"
          ></el-option>
        </el-select>
        <el-date-picker
                v-model="queryDataTime"
                type="daterange"
                start-placeholder="申请时间区间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                size="small"
                class="mr10">
          ></el-date-picker>
        <el-input size="small" placeholder="输入提现单号"  clearable class="mr10"  v-model="conditionQuery.keyWord"></el-input>
        <el-button size="small" type="primary" @click="queryLists">查询</el-button>
      </div>
    </div>

    <hm-content class="mt10"  v-if="active == 0">
      <div >
        <el-table
                :key="Math.random()"
            :data="list"
            border
            stripe
            size="small"
            style="width: 100%">
          <el-table-column
              type="selection"
              width="55">
          </el-table-column>
          <el-table-column type="index" width="50" label="序号"></el-table-column>
          <el-table-column
              prop="auditState"
              label="状态"
              header-align="center"
              align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.auditState == 'wait'" class="blue">{{ getAuditVal(scope.row.auditState) }}</span>
              <span v-if="scope.row.auditState != 'wait'">{{ getAuditVal(scope.row.auditState) }}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="getcashSn"
              label="提现单号"
              header-align="center"
              align="center"
          >
          </el-table-column>
          <el-table-column
              prop="storeName"
              label="代理商"
              header-align="center"
              align="center"
          >
          </el-table-column>
          <el-table-column
              prop="getcashName"
              label="会员姓名"
              header-align="center"
              align="center"
          >
          </el-table-column>
          <el-table-column
              prop="getcashMobile"
              label="电话号码"
              header-align="center"
              align="center"
          >
            <template slot-scope="scope">
              <span >
                {{scope.row.getcashMobile}}
              </span>
            </template>
          </el-table-column>
          <el-table-column
              prop="idcardNo"
              label="身份证号"
              header-align="center"
              align="center"
          >
          </el-table-column>
          <el-table-column
              prop="getcachApplyTime"
              label="申请时间"
              header-align="center"
              align="center"
          >
            <template slot-scope="scope">
              <span >
                {{scope.row.getcachApplyTime}}
              </span>
            </template>
          </el-table-column>
          <el-table-column
              prop="getcashMoney"
              label="申请金额"
              header-align="center"
              align="center"
          >
            <template slot-scope="scope">
              <span style="color: #FF7F10;">
                ¥{{scope.row.getcashMoney}}
              </span>
            </template>
          </el-table-column>
          <el-table-column
              prop="auditTime"
              label="审核时间"
              header-align="center"
              align="center"
          >
            <template slot-scope="scope">
              <span >
                {{scope.row.auditTime}}
              </span>
            </template>
          </el-table-column>
          <el-table-column
              prop="auditUsername"
              label="审核人"
              header-align="center"
              align="center"
          >
          </el-table-column>
          <el-table-column
              prop="callbackOrderSn"
              label="微信支付回执单号"
              header-align="center"
              align="center"
          >
          </el-table-column>
          <el-table-column
              prop="callbackStatus"
              label="微信支付结果状态"
              header-align="center"
              align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.callbackStatus == "fail" ? "失败" : "成功" }}
            </template>
          </el-table-column>
          <el-table-column
              prop="callbackMsg"
              label="微信支付结果信息"
              header-align="center"
              align="center"
          >
          </el-table-column>
          <el-table-column
              prop="callbackReceiveAccount"
              label="付款账号"
              header-align="center"
              align="center"
          >
          </el-table-column>
          <el-table-column
              prop="refuseReason"
              label="驳回备注"
              header-align="center"
              align="center"
          >
          </el-table-column>
          <el-table-column
              label="操作"
              header-align="center"
              align="center"
              fixed="right"
              width="80"
          >
            <template slot-scope="scope">
              <el-button type="text" class="blue" size="small" @click="toCat(scope.row)"
              >提现账单</el-button
              >
              <el-button type="text" class="blue" size="small" v-if="scope.row.auditState == 'wait'" @click="auditSucc(scope.row)"
              >通过</el-button
              >
              <el-button type="text" size="small" v-if="scope.row.auditState == 'wait'" @click="toFail(scope.row)"
              >驳回</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
              background
              :total="total"
              @current-change="paging"
              @size-change="handleSizeChange"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="currentPage"
          ></el-pagination>
        </div>
      </div>
      <el-dialog :visible.sync="grzdDialog" title="企业账单" width="1200px" >
       <!-- <div class="mt20">
          <el-radio-group v-model="dialogTableRadio" size="small" @change="dialogTableRadioChange">
            <el-radio-button :label="'tgfyzd'">推广返佣账单</el-radio-button>
            <el-radio-button :label="'txzd'" >提现账单</el-radio-button>
          </el-radio-group>
        </div>-->
        <div class="mt20">
          <el-table
              :data="dialogShowList"
              border
              stripe
              size="small"
              style="width: 100%">
            <!--<el-table-column
                prop="name"
                label="姓名"
                header-align="center"
                align="center"
            >
            </el-table-column>
            <el-table-column
                prop="type"
                label="电话"
                header-align="center"
                align="center"
            >
            </el-table-column>
            <el-table-column
                prop="time"
                label="身份证号"
                header-align="center"
                align="center"
            >
            </el-table-column>-->
            <el-table-column
                prop="storeName"
                label="企业名称"
                header-align="center"
                align="center"
            >
            </el-table-column>
            <el-table-column
                prop="allowGetcashMoneyAmount"
                label="可提现"
                header-align="center"
                align="center"
            >
              <template slot-scope="scope">
              <span style="color: #FF0000;">
                ￥{{scope.row.allowGetcashMoneyAmount}}
              </span>
              </template>
            </el-table-column>
            <el-table-column
                prop="beingGetcashMoneyAmount"
                label="待发放"
                header-align="center"
                align="center"
            >
            </el-table-column>
            <el-table-column
                prop="hasGetcashMoneyAmount"
                label="已提现"
                header-align="center"
                align="center"
            >
              <template slot-scope="scope">
              <span style="color: #FF7F10;">
                ￥{{scope.row.hasGetcashMoneyAmount}}
              </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="flex flex-end item-center" style="margin-top: 30px">
          <el-date-picker
              v-model="historySearchCondition.queryTime"
              clearable
              size="small"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="申请开始日期"
              end-placeholder="申请结束日期">
          </el-date-picker><!--
          <el-date-picker
              v-model="historySearchCondition.queryTime"
              v-if="dialogTableRadio === 'txzd'"
              clearable
              class="ml10"
              size="small"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="审核开始日期"
              end-placeholder="审核结束日期">
          </el-date-picker>-->
          <el-input
              placeholder="请输入提现单号"
              v-model="historySearchCondition.keyWord"
              size="small"
              class="ml10 mr20"
              clearable>
          </el-input>
          <el-button type="primary" size="small" @click="dialogPaging(1)"
          >查询</el-button
          >
        </div>
        <div class="mt20">
          <!--<el-table
              :data="dialogTgfyzdHistoryList"
              v-if="dialogTableRadio === 'tgfyzd'"
              border
              stripe
              size="small"
              style="width: 100%">
            <el-table-column
                prop="name"
                label="提现单号"
                header-align="center"
                align="center"
            >
            </el-table-column>&lt;!&ndash;
            <el-table-column
                prop="type"
                label="小票号"
                header-align="center"
                align="center"
            >
            </el-table-column>&ndash;&gt;
            <el-table-column
                prop="time"
                label="申请时间"
                header-align="center"
                align="center"
            >
            </el-table-column>
           &lt;!&ndash; <el-table-column
                prop="num"
                label="小票日期"
                header-align="center"
                align="center"
            >
            </el-table-column>&ndash;&gt;
            <el-table-column
                prop="num"
                label="销售商品数量"
                header-align="center"
                align="center"
            >
              <template slot-scope="scope">
              <span style="color: #FF0000;">
                {{scope.row.dlsfr}}
              </span>
              </template>
            </el-table-column>
            <el-table-column
                prop="num"
                label="代理商收益"
                header-align="center"
                align="center"
            >
            </el-table-column>
          </el-table>-->
          <el-table
              :data="dialogTgfyzdHistoryList"
              border
              stripe
              size="small"
              style="width: 100%">
            <el-table-column
                prop="getcashSn"
                label="提现单号"
                header-align="center"
                align="center"
            >
            </el-table-column>
            <el-table-column
                prop="getcachApplyTime"
                label="申请时间"
                header-align="center"
                align="center"
            >
            </el-table-column>
            <el-table-column
                prop="auditTime"
                label="审核时间"
                header-align="center"
                align="center"
            >
            </el-table-column>
            <el-table-column
                prop="auditUsername"
                label="审核人"
                header-align="center"
                align="center"
            >
            </el-table-column>
            <el-table-column
                prop="getcashMoney"
                label="代理商收益"
                header-align="center"
                align="center"
            >
              <template slot-scope="scope">
              <span style="color: #FF7F10;">
                ￥{{scope.row.getcashMoney}}
              </span>
              </template>
            </el-table-column>
          </el-table>
          <div class="hm-pagination">
            <el-pagination
                background
                :total="dialogTotal"
                @current-change="dialogPaging"
                @size-change="dialogHandleSizeChange"
                layout="total, sizes, prev, pager, next, jumper"
                :current-page="dialogCurrentPage"
            ></el-pagination>
          </div>
        </div>
      </el-dialog>

      <el-dialog :visible.sync="failDialog" :title="'确认驳回'" width="580px">
        <el-form :model="ruleForm"  ref="guaQiForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="驳回原因" prop="desc">
            <el-input type="textarea" v-model="ruleForm.remark" placeholder="请输入驳回原因" style="width: 80%"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer flex flex-center mt20">
          <el-button type="primary" size="small" @click="auditFail">
            提交</el-button
          >
          <el-button type="info" size="small" @click="guaQiDialog = false">
            取消</el-button
          >
        </div>
      </el-dialog>
    </hm-content>
    <hm-content class="mt10" v-if="active == 1">
      <el-table :data="tableData" :key="Math.random()">
        <el-table-column
                type="index"
                align="center"
                label="序号"
                :index="index => index + (currentPages - 1) * pageSizes + 1"
        ></el-table-column>
        <el-table-column
                align="center"
                label="提现单号"
                prop="getcashSn"
        ></el-table-column>
        <el-table-column
                align="center"
                label="申请时间"
                prop="getcachApplyTime"
        ></el-table-column>
        <el-table-column
                align="center"
                label="审核时间"
                prop="auditTime"
        ></el-table-column>
        <el-table-column
                align="center"
                label="提现金额"
                prop="getcashMoney"
        ></el-table-column>
        <el-table-column
                align="center"
                label="提现申请人"
                prop="getcashName"
        ></el-table-column>
        <el-table-column
                align="center"
                label="申请手机号"
                prop="getcashMobile"
        ></el-table-column>
        <el-table-column
                align="center"
                label="申请途径"
                prop="getcashType"
        ></el-table-column>
        <el-table-column
                align="center"
                label="收款账号"
                prop="sendWay"
        ></el-table-column>
        <el-table-column
                align="center"
                label="提现状态"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.auditState == 'wait'" style="color: #0081E5">待审核</span>
            <span v-if="scope.row.auditState == 'refuse'" style="color: #FF0000">驳回</span>
            <span v-if="scope.row.auditState == 'agree'" style="color: #2FC348">通过</span>
          </template>
        </el-table-column>
         <el-table-column
                align="center"
                label="审核人"
                prop="auditUsername"
        ></el-table-column>
        <el-table-column
                align="center"
                label="提现驳回原因"
                prop="refuseReason"
        ></el-table-column>
        <el-table-column
                align="center"
                label="操作"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.auditState == 'wait'">
              <el-button
                      style="color: #0081E5"
                      size="small"
                      type="text"
                      @click="pass(scope.row,'agree')"
              >通过</el-button>
            <el-button
                    size="small"
                    type="text"
                    @click="pass(scope.row,'refuse')"
            >驳回</el-button>
            </span>
            <span v-else style="color: #666666">
              已审核
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
                background
                :total="totals"
                @current-change="paging"
                @size-change="handleSizeChange"
                layout="total, sizes, prev, pager, next, jumper"
                :current-page="currentPages"
        ></el-pagination>
        <el-dialog :visible.sync="refuceWindow" title="请输入驳回原因" width="30%">
            <el-input type="textarea"
                      :rows="4"
                      placeholder="请输入驳回原因"
                      v-model="refuseText">
            </el-input>
          <div class="flex flex-center" style="margin-top: 30px;">
            <el-button type="primary" size="small" class="mr10" @click="refuseWait">确认</el-button>
            <el-button size="small" @click="refuceWindow = false">取消</el-button>
          </div>
        </el-dialog>
      </div>
    </hm-content>
  </div>
</template>

<script>
export default {
  data() {
    return {
      refuseText:'',
      refuceWindow:false,
      auditState:[
        {
          value:'wait',
          label:'待审核'
        },
        {
          value:'refuse',
          label:'已驳回'
        },
        {
          value:'agree',
          label:'通过'
        },
      ],
      queryDataTime:"",
      conditionQuery:{
        auditState:'',
        keyWord:'',
      },
      totals:0,
      tableData:[],
      currentPages:1,
      pageSizes:10,

      active:0,
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {
        queryTime: [],
        auditState: "",
        keyWord: ""
      },
      statusList: [
        {
          label: "待审核",
          value: "wait"
        },
        {
          label: "审核通过",
          value: "agree"
        },
        {
          label: "驳回",
          value: "refuse"
        }
      ],
      grzdDialog: false,
      dialogTableRadio: "tgfyzd",
      dialogShowList: [],
      dialogTgfyzdHistoryList: [],
      dialogTxzdHistoryList: [],
      historySearchCondition: {
        queryTime: [],
        keyWord: ""
      },
      dialogTotal: 0,
      dialogCurrentPage: 1,
      dialogPageSize: 10,
      row: "",
      failDialog: false,
      ruleForm: {
        remark: ""
      },
      val:'',
    };
  },
  created() {
    this.queryList();
    this.queryLists();
  },
  mounted() {},
  methods: {
    toCat(row) {
      this.row = row;
      this.historySearchCondition = {
        queryTime: [],
        keyWord: ""
      };
      this.dialogTgfyzdHistoryList = [];
      this.dialogShowList = [];
      this.dialogShowList.push(row);
      this.grzdDialog = true;
      console.log("row", this.row)
      this.queryDialogList();
    },
    toFail(row) {
      this.row = row;
      this.ruleForm = {
        remark: ""
      };
      this.failDialog = true;
    },
    auditFail() {
      let params = {
        id: this.row.id,
        getcashSn: this.row.getcashSn,
        auditState: "refuse",
        refuseReason: this.ruleForm.remark
      };
      this.audit(params);
    },
    auditSucc(row) {
      this.row = row;
      this.$confirm(" 是否通过该条提现记录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let params = {
          id: this.row.id,
          getcashSn: this.row.getcashSn,
          auditState: "agree"
        };
        this.audit(params);
      });
    },
    //审核
    async audit(params) {
      await this.$store.dispatch("agentTiXianAudit", params);
      this.failDialog = false;
      this.$message({
        message: " 操作成功",
        type: "success"
      });
      this.queryList();
    },
    //获取审核状态
    getAuditVal(str) {
      let val = "";
      if (str == "wait") {
        val = "待审核";
      }else if (str == "agree") {
        val = "审核通过";
      }else if (str == "refuse") {
        val = "驳回";
      }
      return val;
    },
    //弹框table切换
    dialogTableRadioChange() {
      this.historySearchCondition = {};
      this.dialogCurrentPage = 1;
      this.dialogPageSize = 10;
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.queryStartTime = this.isArray(searchCondition.queryTime) && searchCondition.queryTime.length > 0 ?
          searchCondition.queryTime[0] + " 00:00:00" : "";
      searchCondition.queryEndTime = this.isArray(searchCondition.queryTime) && searchCondition.queryTime.length > 0 ?
          searchCondition.queryTime[1] + " 23:59:59" : "";
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch("queryTiXianList", params);
      if (code === "0") {
        const { total, records } = result;
        this.list = records;
        this.total = total;
      }
    },
    //查询弹框数据
    async queryDialogList() {
      const params = {
        pageSize: this.dialogPageSize,
        pageNo: this.dialogCurrentPage,
        storeCode: this.row.storeCode,
        auditState: "agree"
      };
      const searchCondition = JSON.parse(JSON.stringify(this.historySearchCondition));
      searchCondition.queryStartTime = this.isArray(searchCondition.queryTime) && searchCondition.queryTime.length > 0 ?
          searchCondition.queryTime[0] + " 00:00:00" : "";
      searchCondition.queryEndTime = this.isArray(searchCondition.queryTime) && searchCondition.queryTime.length > 0 ?
          searchCondition.queryTime[1] + " 23:59:59" : "";
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch("queryTiXianList", params);
      if (code === "0") {
        const { total, records } = result;
        this.dialogTgfyzdHistoryList = records;
        this.dialogTotal = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    dialogPaging(page) {
      this.dialogCurrentPage = page;
      this.queryDialogList();
    },
    dialogHandleSizeChange(size) {
      this.dialogCurrentPage = 1;
      this.dialogPageSize = size;
      this.queryDialogList();
    },
    async queryLists(){
      let params = {
        pageSize: this.pageSizes,
        pageNo:this.currentPages
      }
      const condition = JSON.parse(JSON.stringify(this.conditionQuery));
      if(this.isArray(this.queryDataTime)){
        condition.queryStartTime =
                this.queryDataTime && this.queryDataTime.length > 0 ? this.queryDataTime[0]: "";
        condition.queryEndTime =
                this.queryDataTime && this.queryDataTime.length > 0 ? this.queryDataTime[1]: "";
      }

      Object.assign(params,condition)
      const { result } = await this.$store.dispatch("cash_out_list",params);
      this.tableData = result.records;
      this.totals = result.records.length;
    },
    pagings(page) {
      this.currentPages = page;
      this.queryList();
    },
    handleSizeChanges(size) {
      this.currentPages = 1;
      this.pageSizes = size;
      this.queryLists();
    },
    async pass(row,status){
      let parms = {
        id:row.id,
        getcashSn:row.getcashSn,
        auditState:status,
        refuseReason:''
      };
      if(status == "refuse"){
        this.refuceWindow = true;
        this.val = parms;
      }else{
        await this.$store.dispatch("cash_out_operate",parms);
        this.$message({
          type: 'success',
          message: '操作成功！'
        });
        this.queryLists();
      }


    },
    async refuseWait(){
      this.val.refuseReason = this.refuseText;
      await this.$store.dispatch("cash_out_operate",this.val);
      this.$message({
        type: 'success',
        message: '驳回成功！'
      });
      this.refuceWindow = false;
      this.queryLists();
    }
  },
};
</script>

<style scoped lang="scss">
.bg {
  background-color: #fff;
  padding: 20px;
}
</style>
